import { useLocation, useNavigate } from "react-router-dom";
import logo from "../logo.svg";
import "./NavBar.css";

function NavBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === "/";
  const isLibrary = location.pathname === "/library";
  const isBrand = location.pathname === "/brand";

  return (
    <header className="navbar">
      <img
        src={logo}
        alt="여백"
        className="navbar-logo"
        onClick={() => navigate("/")}
      />
      <div className="navbar-actions">
        <button
          className={`navbar-btn${isBrand ? " active" : ""}`}
          onClick={() => navigate("/brand")}
          title="브랜드 소개"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 3l7 4v10l-7 4-7-4V7l7-4z" />
            <path d="M9 10.5h6" />
            <path d="M9 13.5h6" />
          </svg>
          <span>소개</span>
        </button>
        <button
          className={`navbar-btn${isLibrary ? " active" : ""}`}
          onClick={() => navigate("/library")}
          title="나의 서재"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
          </svg>
          <span>서재</span>
        </button>
        <button
          className={`navbar-btn${isHome ? " active" : ""}`}
          onClick={() => navigate("/")}
          title="기록하기"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 20h9" />
            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
          </svg>
          <span>기록</span>
        </button>
      </div>
    </header>
  );
}

export default NavBar;
